import { Injectable } from '@angular/core';
import { ConfigurationMetaData, ConfigurationTemplate } from './wizard-model.interface';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export abstract class WizardModel {

  public abstract readonly type: string;
  public metaData: ConfigurationMetaData = {};

  private _config?: ConfigurationTemplate;

  public get config(): ConfigurationTemplate {
    if (!this._config) {
      this._config = this.createConfig();
    }
    return this._config;
  }

  protected abstract createConfig(): ConfigurationTemplate;

  public abstract create(): Promise<void>;

  public abstract selectValue(step: number, value: any | undefined): void;

  public creationStarted = false;

  public get numberOfSteps(): number {
    return this.config.steps.length;
  }

  protected _currentStepIndex$ = new BehaviorSubject(0);

  public get currentStepIndex$() {
    return this._currentStepIndex$.asObservable();
  }

  public get currentStepIndex(): number {
    return this._currentStepIndex$.getValue();
  }

  public get currentStep$() {
    return this._currentStepIndex$.pipe(map(index => this.config.steps[index]));
  }

  public get currentStep() {
    return this.config.steps[this.currentStepIndex];
  }

  public async nextStep(): Promise<void> {
    this._currentStepIndex$.next(this.currentStepIndex + 1);
  }

  public async previousStep(): Promise<void> {
    this._currentStepIndex$.next(this.currentStepIndex - 1);
  }

  public get progressStepsVisible(): boolean {
    return this.config.type === 'assistant';
  }
}
